<div class="header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <span>Funded Details</span>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" class="custom-mat-field">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="details">
    <div class="mt-4">
        <mat-accordion multi>
            <form [formGroup]="form">
                <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            </form>
        </mat-accordion>
    </div>
</div>